// Email Confirmation Status Modal
// Parses URL parameters and shows a Bootstrap-styled modal indicating
// whether email confirmation succeeded or failed.

(function () {
  function parseStatus() {
    const url = new URL(window.location.href);
    const p = url.searchParams;

    // Preferred explicit flag we set in redirectTo (check both URL and sessionStorage)
    let explicit = p.get('email-confirmation'); // 'success' | 'failed'
    if (!explicit) {
      try {
        explicit = sessionStorage.getItem('auth:email_confirmation');
        if (explicit) sessionStorage.removeItem('auth:email_confirmation');
      } catch (_) {}
    }

    // Supabase may append error indicators on failure
    const sbError = p.get('error') || p.get('error_code') || p.get('error_description');

    // If explicit is set, start with it; otherwise infer from Supabase params
    let status = explicit ? explicit.toLowerCase() : null;

    // If Supabase indicates an error, treat as failure regardless of explicit flag
    if (sbError) status = 'failed';

    // Only show modal when we have a status
    return status; // 'success' | 'failed' | null
  }

  function trackEmailConfirmation(status) {
    try {
      if (!window.gtag) return;
      const isSuccess = status === 'success';
      const params = {
        method: 'email',
        status: isSuccess ? 'success' : 'failed',
        surface: 'Desktop'
      };
      window.gtag('event', 'email_confirmation', params);
      window.gtag('event', `Desktop_TopNav_Account_EmailConfirmation${isSuccess ? 'Success' : 'Failed'}`, params);
    } catch (_) {}
  }

  function buildModal(status) {
    const isSuccess = status === 'success';

    const modal = document.createElement('div');
    modal.id = 'emailConfirmStatusModal';
    modal.className = 'modal fade';
    modal.tabIndex = -1;
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header ${isSuccess ? 'bg-success-subtle' : 'bg-danger-subtle'}">
            <h5 class="modal-title d-flex align-items-center gap-2">
              <i class="bi ${isSuccess ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}"></i>
              ${isSuccess ? 'Email Confirmed' : 'Email Confirmation Failed'}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            ${isSuccess
              ? '<p class="mb-2">Your email address has been confirmed successfully.</p><p class="mb-0 text-muted small">You can close this window and continue using the app.</p>'
              : '<p class="mb-2">We were unable to confirm your email address.</p><p class="mb-0 text-muted small">The link may have expired or was already used. Please request a new confirmation email and try again.</p>'}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn ${isSuccess ? 'btn-success' : 'btn-danger'}" data-bs-dismiss="modal">OK</button>
          </div>
        </div>
      </div>`;

    document.body.appendChild(modal);
    return modal;
  }

  function showModal(status) {
    const isSuccess = status === 'success';
    const textToShow = isSuccess ? 'Your email address has been confirmed successfully' : 'We were unable to confirm your email address.';
    if (window.AuthUI && window.AuthUI.showMessage) {
      window.AuthUI.showMessage(textToShow, !isSuccess);
    }
    
  }

  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    const status = parseStatus();
    if (!status) return;
    trackEmailConfirmation(status);
    showModal(status);
  });
})();
